export class LocalSettings {
    constructor() {
        this.prefix = 'bb_setting_'; // Prefix for all settings
    }

    // Helper function to safely get nested object properties
    _getNestedValue(obj, path) {
        if (!path) return obj;
        const properties = path.split('.');
        let value = obj;
        for (const prop of properties) {
            if (value === null || value === undefined || typeof value !== 'object') {
                return null;
            }
            value = value[prop];
        }
        return value;
    }

    set(key, value) {
        localStorage.setItem(this.prefix + key, JSON.stringify(value));
    }

    get(key, propertyPath) {
        const storedValue = localStorage.getItem(this.prefix + key);
        if (storedValue === null || storedValue === undefined) return null;
        try {
            const value = JSON.parse(storedValue);
            return propertyPath ? this._getNestedValue(value, propertyPath) : value;
        } catch (error) {
            console.error(`Error parsing setting ${key}:`, error);
            return null;
        }
    }

    remove(key) {
        localStorage.removeItem(this.prefix + key);
    }

    clear() {
        // Only clear items with our prefix
        Object.keys(localStorage)
            .filter(key => key.startsWith(this.prefix))
            .forEach(key => localStorage.removeItem(key));
    }

    getAllKeys() {
        return Object.keys(localStorage)
            .filter(key => key.startsWith(this.prefix))
            .map(key => key.replace(this.prefix, ''));
    }
}

// Create a singleton instance
export const localSettings = new LocalSettings(); 